import { Component, input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { EnrichedProduct } from '../../store/webshop/webshop.models';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-product-card',
  standalone: true,
  imports: [
    CommonModule,
    NgOptimizedImage,
    RouterLink
  ],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss'
})
export class ProductCardComponent {
  product = input.required<EnrichedProduct>();

  get title() {
    return this.product().enrichedAttributes.find(attr => attr.name === 'Titel')?.displayValue;
  }

  get productCode() {
    return this.product().enrichedAttributes.find(attr => attr.name === 'Productcode')?.displayValue;
  }

  get productLink() {
    const category = this.product().category;
    if (category) {
      if (category.parentCategory) {
        return ['/producten', category.parentCategory.slug, category.slug, this.product().id];
      }
      return ['/producten', category.slug, this.product().id];
    }
    return ['/producten', 'algemeen', this.product().id];
  }
}
